import { Link } from "react-router-dom"
import { ArticlesFilteredsTypes } from "../../../models/news-articles/articles-filtered-model"

type NewsAndArticleCardTypes = {
  cardSecTitle: string
  cardSecSubTitle: string
  cardSecContent: string
  cardSecInfo: string
  article: ArticlesFilteredsTypes[]
}

const DepartmentsSliderCard400 = (props: NewsAndArticleCardTypes) => {

  const ArticlesFilteredsData400 = props.article

  return <div className={`feature-single ${props.cardSecTitle}`}>
    <Link to='/news-and-articles/news-articles?category=400'>
      <div className={props.cardSecSubTitle}>Roundups</div>
    </Link>
    <Link to={ArticlesFilteredsData400[0]?.articlesList[0]?.articleUrl}>
      <img src={ArticlesFilteredsData400[0]?.articlesList[0]?.articleTeaserImage} alt={ArticlesFilteredsData400[0]?.articlesList[0]?.articleName} loading="lazy" />
    </Link>
    <div className={props.cardSecContent}>
      <div className={props.cardSecInfo} >
        <ul>
          {(ArticlesFilteredsData400[0]?.articlesList?.length > 1) ? (
              <>
                {
                  ArticlesFilteredsData400[0]?.articlesList.map((item, index) => {
                    return <li key={index}>
                      <Link to={item.articleUrl} dangerouslySetInnerHTML={{ __html: item.articleName }}></Link>
                    </li>
                  })
                }
                <li>
                  {
                    (ArticlesFilteredsData400[0]?.articlesList.length > 1) && <Link to='/news-and-articles/news-articles?category=400' className="view-more">See more</Link>
                  }
                </li>
              </>

            ) : (
              <li>
                <Link to={ArticlesFilteredsData400[0]?.articlesList[0].articleUrl} dangerouslySetInnerHTML={{ __html: ArticlesFilteredsData400[0]?.articlesList[0]?.articleName }}></Link>
                <p dangerouslySetInnerHTML={{ __html: ArticlesFilteredsData400[0]?.articlesList[0]?.articleTeaserText }}></p>
              </li>
            )}
        </ul>
      </div>
    </div>
  </div>
}

export default DepartmentsSliderCard400
